'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _ReactIframeResizerSuper = require('../external/ReactIframeResizerSuper');
var _ReactIframeResizerSuper2 = _interopRequireDefault(_ReactIframeResizerSuper);
var _urls = require('../../constants/urls');
var _urls2 = _interopRequireDefault(_urls);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var allowedOrigins = ['https://live.eventtia.com', 'https://connect.eventtia.com'];
var RegistrationIframe = function (_Component) {
  _inherits(RegistrationIframe, _Component);
  function RegistrationIframe() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, RegistrationIframe);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegistrationIframe.__proto__ || Object.getPrototypeOf(RegistrationIframe)).call.apply(_ref, [this].concat(args))), _this), _this.scrollIfRequested = function (_ref2) {
      var data = _ref2.data,
        origin = _ref2.origin;
      var registrationIframe = document.getElementsByClassName('registration-iframe')[0];
      if (!!registrationIframe && allowedOrigins.includes(origin) && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && !!data.scrollToConnectIframe) {
        var box = registrationIframe.getBoundingClientRect();
        var body = document.body;
        var docEl = document.documentElement;
        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var clientTop = docEl.clientTop || body.clientTop || 0;
        var top = box.top + scrollTop - clientTop;
        window.scroll(0, top);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(RegistrationIframe, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener("message", this.scrollIfRequested);
    }
  }, {
    key: 'render',
    value: function render() {
      var entities = this.props.entities;
      var _Object$keys$map$ = Object.keys(entities).map(function (k) {
          return entities[k];
        })[0],
        eventUri = _Object$keys$map$.eventUri,
        eventId = _Object$keys$map$.id;
      var iframeResizerOptions = {
        checkOrigin: false,
        inPageLinks: true
      };
      return _react2.default.createElement('div', null, _react2.default.createElement(_ReactIframeResizerSuper2.default, {
        className: 'registration-iframe',
        iframeResizerOptions: iframeResizerOptions,
        iframeResizerUrl: false,
        src: _urls2.default.getPublicRegisterUrl(eventUri, undefined, parseInt(eventId)),
        allow: 'payment; camera; microphone'
      }));
    }
  }]);
  return RegistrationIframe;
}(_react.Component);
exports.default = RegistrationIframe;